/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum LanguageProficiency {
  basic = "basic",
  proficient = "proficient",
  fluent = "fluent",
}

export const LanguageProficiencyDisplay: Record<LanguageProficiency, string> = {
  [LanguageProficiency.basic]: "Basic",
  [LanguageProficiency.proficient]: "Proficient",
  [LanguageProficiency.fluent]: "Fluent",
};
